import { 
  Box,TextField, Chip
} from '@mui/material';
import { useState } from 'react';

// --- COMPONENTE TAG INPUT ---
export default function TagInput({ label, value = [], onChange, placeholder }) {
  const [input, setInput] = useState('');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const newTag = input.trim().toLowerCase();
      if (!newTag || value.includes(newTag)) {
        setInput('');
        return;
      }
      onChange([...value, newTag]);
      setInput('');
    }
  };

  const handleDelete = (tagToDelete) => {
    onChange(value.filter(tag => tag !== tagToDelete));
  };

  return (
    <Box>
      <TextField
        label={label}
        fullWidth
        placeholder={placeholder || 'Escribe y presiona Enter'}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      {value.length > 0 && (
        <Box mt={1} sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {value.map((tag) => (
            <Chip
              key={tag}
              label={tag}
              onDelete={() => handleDelete(tag)}
              size="small"
              color="primary"
              variant="outlined"
            />
          ))}
        </Box>
      )}
    </Box>
  );
}